import { createStyles } from '@mantine/styles';

var useStyles = createStyles({
  root: {
    position: "relative"
  },
  label: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  }
});

export default useStyles;
//# sourceMappingURL=RingProgress.styles.js.map
